import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent, MatDialog, MatTableDataSource, MatSort, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { from, Observable } from 'rxjs';
import { AddUserModalComponent } from '../add-user-modal/add-user-modal.component';
import { AccidentService } from '../../services/accident.service'
import { AccidentUserService } from '../../services/accident-user.service'
import { UtilityService } from '../../services/utility.service';
import { FilterService } from 'src/app/services/filter.service';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { UserDocumentService } from '../../services/user-document.service'
import { saveAs } from "file-saver";
import * as moment from 'moment';
import { error } from 'selenium-webdriver';
import { EditStaffModalComponent } from 'src/app/staff/edit-staff-modal/edit-staff-modal.component';
import { AssetService } from 'src/app/services/asset.service';
import { accidentUserRoles } from '../../_models/staticArray'
import { FormControl, FormGroup } from '@angular/forms';
// export interface PeriodicElement {
//   name: string;
//   userRole: string;
//   form: string;
//   date: string;
// }

// const ELEMENT_DATA: PeriodicElement[] = [
//   { name: 'test1', userRole: 'Investigation Officer', form: 'Environment Incident Reporting Form', date: '20 Jan 2020' },
//   { name: 'demo', userRole: 'Witness', form: 'Environment Incident Reporting Form', date: '20 Jan 2020' },
//   { name: 'test3', userRole: 'Witness', form: 'Environment Incident Reporting Form', date: '20 Jan 2020' },
// ];


@Component({
  selector: 'app-single-accident',
  templateUrl: './single-accident.component.html',
  styleUrls: ['./single-accident.component.scss']
})
export class SingleAccidentComponent implements OnInit {
  // dataSource1 = ELEMENT_DATA
  accident: FormGroup;
  selectedRole = ['']
  roleType = accidentUserRoles
  //  [ { key: 'Witness', value: 'witness' }, { key: 'Reporters', value: 'reporter' }, { key: 'Investigation Officer', value: 'officer' }]
  // roleType = ['Investigation Officer', 'Witness', 'Reporter']
  displayedColumns: string[] = ['name', 'userRole', 'form', 'status', 'date', 'action'];
  dataSource: MatTableDataSource<any>;
  accidentId
  singleAccident: any
  title
  date
  userList: any = []
  location
  users: any = [];
  loading: Boolean
  sort: MatSort;
  paginator: MatPaginator;
  afterFilter: any
  searchText: string = '';
  filterActive: Boolean = false;
  tempDataSource = []
  tempData = []
  noDataMsg = {
    title: "No Users!",
    data: "You have not yet added any users"
  }
  data: any;
  isAccidentUser: boolean = true
  isSpinner
  spinnerId
  address: any;
  currentUser = JSON.parse(localStorage.getItem('currentUser'))
  userRole = JSON.parse(localStorage.getItem('userRoles'))
  isDisplay: boolean = true
  isDisable = true
  constructor(
    public dialog: MatDialog,
    public _accidentUsers: AccidentUserService,
    public activatedRouter: ActivatedRoute,
    public router: Router,
    public accidentService: AccidentService,
    public _utilityService: UtilityService,
    private _filter: FilterService,
    public dialogRef: MatDialogRef<any>,
    public _assetService: AssetService,
    public _userDocumentService: UserDocumentService
  ) {
    // this.dataSource = new MatTableDataSource()
  }

  @ViewChild(MatSort, { static: false }) set matSort(ms: MatSort) {
    this.sort = ms;
    // this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    // this.setDataSourceAttributes();
  }

  // setDataSourceAttributes() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }


  ngOnInit() {
    this.creatCloseCallForm()
    this._assetService.closeDisplayFile(true)
    this.activatedRouter.queryParams.subscribe(params => {
      console.log('check params data..', params)
      this.accidentId = params.accidentId;
      this.getSingleAccident()
    })
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  // FORM GROUP

  creatCloseCallForm(data?) {
    this.accident = new FormGroup({
      ELR: new FormControl((data && data.ELR) ? data.ELR : ''),
      mileage: new FormControl((data && data.mileage) ? data.mileage :''),
      closecallRadio1: new FormControl((data && data.closecallRadio1) ? data.closecallRadio1 :''),
      closecallRadio2: new FormControl((data && data.closecallRadio2) ? data.closecallRadio2 :''),
      pcReport: new FormControl((data && data.pcReport) ? data.pcReport :''),
    })
    if (this.isDisable) this.accident.disable()
  }


  // UTILITY


  editIncidentDetails() {
    this.isDisable = !this.isDisable
    if (this.isDisable) {
      this.accident.disable()
      this.submitIncidentDetails()
    }
    else this.accident.enable()
  }

  updateData(users) {
    console.log("UPDATING DATA = ", users)
    console.log("Emitting event with users = ", users);
    this.dataSource = new MatTableDataSource(users);
    console.log("DataSource value = ", this.dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'name': return item.name;
        case 'userRole': return item.userRole;
        case 'form': return item.userRole;
        case 'status': return item.status;
        case 'date': return item.submissionDate;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;
  }


  checkForm(data) {

    if (this.singleAccident.type == 'goodPractice')
      return 'Good-Practice Form'

    else if ((this.singleAccident.type == 'closeCall' || this.singleAccident.type == 'nearMiss') && data.userRole == 'witness')
      return 'Witness Form'

    else if ((this.singleAccident.type == 'closeCall' || this.singleAccident.type == 'nearMiss') && data.userRole == 'officer')
      return 'Incident Investigation Report Form'

    else if (this.singleAccident.type == 'closeCall' && data.userRole == 'reporter')
      return 'Close-Call Form'

    else if (this.singleAccident.type == 'nearMiss' && data.userRole == 'reporter' && data.userForm == 'envForm')
      return 'Environmental Incident Form'

    else
      return 'Incident-Reporting Form'
  }


  checkStatus(item) {

    switch (item.userRole) {
      case 'witness':
        return item.status
        break;

      case 'reporter':
        // if (item.envStatus)

        return item.status
        // else
        //   return 'Pending'
        break;
      case 'officer':
        return item.status
        break;

      default:
        return 'Pending'
        break;
    }

  }
  checkOtherStatus(item) {
    switch (item.userRole) {
      case 'reporter':
        if (item.irStatus)
          return item.irStatus
        else
          return 'Pending'
        break;
      default:
        return 'Pending'
        break;
    }
  }



  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  getUserRoleColor(item) {
    switch (item) {
      case 'witness':
        return 'witness'
        break;

      case 'reporter':
        return 'incident-reporter'
        break;
      case 'officer':
        return 'investigation-officer'
        break;

      default:
        break;
    }
  }

  getStatusColor(item) {
    switch (item) {
      case 'closeCall':
        return 'close-call'
        break;

      case 'accident':
        return 'accident'
        break;

      case 'incidents':
        return 'incident'
        break;

      case 'goodPractice':
        return 'good-practice'
        break;

      case 'nearMiss':
        return 'near-miss'
        break;

      default:
        break;
    }
  }

  checkType(element) {
    if (element == 'closeCall')
      return "Close Call"
    else if (element == 'incidents')
      return "Incident"
    else if (element == 'goodPractice')
      return "Good Practise"
    else
      return "Accident/Near Miss"
  }

  filter(searchText) {
    this.afterFilter = null
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.updateData(this.userList);
      this.filterActive = false
      this.afterFilter = null
      return;
    }
    console.log("filter Time pass data..", this.userList)
    let tempDataSource = this._filter.filter(searchText, this.userList, ['name', 'userRole'], 'newfilter');
    this.updateData(tempDataSource);
    if (tempDataSource.length <= 0) {
      this.filterActive = true
      this.afterFilter = {
        title: "No Users!",
        data: "Sorry, no user matched your search"
      }
    }
  }

  selectedRoleChanged() {

    let array1 = []
    let array2 = this.selectedRole;
    console.log("this.selectedRole", this.selectedRole);

    if (array2 && array2.length) {
      array1 = this.userList.filter(function (item) {
        return array2.includes(item.userRole);
      })
    }

    if (!array2.length) {
      this.updateData(this.userList);
      this.filterActive = false
      this.afterFilter = null
      return;
    }

    console.log('selected type for filter.................', array1)
    if (array1.length <= 0) {
      this.filterActive = true
      this.afterFilter = {
        title: "No Users!",
        data: "Sorry, no user matched your selected role!"
      }
    } else {
      this.filterActive = false
      this.afterFilter = null
    }
    this.updateData(array1)

  }


  addUserModal() {
    console.log("dkjsa", this.singleAccident);
    let data = {
      accidentId: this.singleAccident._id,
      accidentType: this.singleAccident.type
    }
    // const dialogRef = this.dialog.open(AddUserModalComponent);
    const dialogRef = this._utilityService.commonDialogBoxOpen(AddUserModalComponent, data)
      .afterClosed().subscribe((response) => {
        if (response == undefined) return
        else {
          console.log("here is user list for update data ====>", response)
          this.userList.push(response)
          this.updateData(this.userList)
          this._utilityService.handleSnackBar({ msg: "User added successfully!", button: "Ok" })
        }
      }, (error) => {
        console.log("something wrong to add user...", error)
        this._utilityService.handleSnackBar({ msg: "Submision Failed Please Check Validation!", button: "Ok" })
      })
  }


  ediUserModal(i, user) {
    console.log("user value at edit ------------>", user);
    user['edit'] = true
    user['accidentUser'] = true;
    user['accidentId'] = this.singleAccident._id
    console.log("check edit curent data...id", i, user, this.singleAccident)
    let obj = {
      userRole: user.userRole,
      accidentType: this.singleAccident.type,
      userId: user,
      accidentId: this.singleAccident._id,
      userForm: user.userForm,
      edit: true
    }
    let array = []
    array.push(user)
    // this.accidentService.editAccidentUserData(obj)
    // this.router.navigate([user.redirectUrl], { queryParams: obj })
    const dialogRef = this._utilityService.commonDialogBoxOpen(AddUserModalComponent, obj).afterClosed()
      .subscribe((data) => {
        if (data == undefined) return
        console.log("edit model data ...", data)
        console.log("this is user list", this.userList);

        if (data) {
          // this.userList.splice(i, 1, data.accident)
          let index = this.userList.findIndex((x) => x.userId == data._id)
          console.log("this is index ", index);
          this.userList[index].userRole = data.userRole
          this.userList[index].userForm = data.userForm
          this.userList[index].formName = data.formName
          if (data && data.name) {
            this.userList[index].name = data.name
          }
          console.log('edit mongodb front end ...........')
          this._utilityService.handleSnackBar({ msg: "User updated successfully!", button: "Ok" })
          this.updateData(this.userList)
          // this.ngOnInit()
        }
      }, (error) => {
        console.log('edit time some error occure!!', error)
        this._utilityService.handleSnackBar({ msg: "User updated Failed!", button: "Ok" })

      }

      )
    // }
  }


  delete(index, user) {
    this.openDialog(DeleteConfirmModalComponent, 'accident user').subscribe(confirm => {
      let data = {
        // userid: user.userId,
        accidentId: this.accidentId
      }

      if (confirm == '') return
      else if (confirm == 'yes') {
        this.loading = true;

        console.log('deleted user details', user)

        /***********
         * delete user accident data here
         * *********************************
         */
        let userData = {}
        userData['accidentId'] = this.accidentId;
        userData['user'] = user;

        this._accidentUsers.deleteAccidentUser(JSON.stringify(userData)).subscribe((data) => {
          console.log('here is the successfully delete response ', data)
          this.loading = false;
          this._utilityService.handleSnackBar({ msg: "User removed successfully!", button: "Ok" })
          console.log("remove user", data);
          console.log("index--->", index, user);
          if (index !== -1) {
            this.userList.splice(index, 1);
          }
          if (!this.userList.length) {
            this.filterActive = false
            this.noDataMsg = {
              title: "No Users!",
              data: "You have not yet added any users"
            }
          }
          this.updateData(this.userList);
        },
          (error) => {
            console.log('accident users delete time some error occure ', error)
            this.loading = false;
            this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })

          })

        // this.router.navigate(['/accident/single-accident'], { queryParams: data })

      }
      // else {
      // this.router.navigate(['/accident/single-accident'], { queryParams: data })
      // }
    })
  }


  openDialog(someComponent, data = {},): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }

  // closoeDialog(result) {
  //   this.dialogRef.close(result);
  // }



  // API CALL

  getSingleAccident() {
    console.log("get single accident here....")
    this.loading = true;
    this.userList = []
    this.singleAccident = {}
    this.accidentService.getAccident(this.accidentId).subscribe((data) => {
      console.log("get single accident data sucessfully....", data)
      // console.log("get single accident data sucessfully....", data.foundAccident)
      if (data.data && data.data.length) {
        this.singleAccident = data.data[0]
        this.address = this.singleAccident && this.singleAccident.location ? this.singleAccident.location.address : ''
        this.userList = this.singleAccident.incidentUsers
        console.log("get single accident data sucessfully....", this.singleAccident)
        console.log("log current user", this.currentUser, this.userRole);

        if ((this.singleAccident.createdBy != null && this.singleAccident.createdBy._id == this.currentUser.userId) && !this.userRole.isAdmin) {
          console.log("call this if part");

          this.isDisplay = false
        } else {
          console.log("call this else part");

          this.isDisplay = true
        }

        if (this.singleAccident && this.singleAccident.type === "closeCall") {
          this.creatCloseCallForm(this.singleAccident && this.singleAccident.details ? this.singleAccident.details : {})
        }


        this.updateData(this.userList)
      } else {
        this.filterActive = false
        this.noDataMsg = {
          title: "No Users!",
          data: "You have not yet added any users!"
        }
        // }
        this.updateData([])
      }
      // this.title = data.foundAccident[0].title
      // this.date = data.foundAccident[0].date
      // this.location = data.foundAccident[0].location
      this.loading = false;
      // console.log("find single accident details.....",this.singleAccident)
    }, (error) => {
      this.loading = false;
      console.log("some thing wrong get single accident", error)
    })
  }

  accidentForm(data) {
    this.loading = true
    console.log("data while redirection", data);
    let param = {
      accidentId: this.accidentId,
      userId: data.userId,
      userRole: data.userRole,
      accidentType: this.singleAccident.type
    }
    console.log("param =====================>", param)
    this.router.navigate(['/accident/accident-form'], { queryParams: param })
    // this.router.navigate(['/accident/'])

  }

  /**
   * Download Before file submission
   * ***********************************************************
   */
  downloadBeforSubmission() {
    this._utilityService.openSnackBar("Form is not submitted. Please submit the form.", "OK")
  }

  /*********************************************************
     * Download protfolio function here 
     */
  download(user) {
    console.log("user status", user.status);
    this.spinnerId = user._id
    this.isSpinner = true

    if (user.status != "Submitted") {
      this._utilityService.openSnackBar("Form is not submitted. Please submit the form.", "OK")
    }
    else {
      console.log('here id user', user)
      let data = {
        userId: user.userId,
        userRole: user.userRole,
        accidentId: this.accidentId
      }
      this._userDocumentService.downloadAccidentPotrfolio(JSON.stringify(data)).subscribe((res) => {
        console.log('here is data response accident pdf genarate', res)

        const downloadLink = document.createElement("a");
        // const fileName = title + ".zip";
        downloadLink.href = res.formPdf;
        downloadLink.download = 'accidentForm_' + moment(new Date).format("DD-MM-YYYY")
        this._utilityService.handleSnackBar({ msg: "File Download Successfully", button: "Ok" })
        downloadLink.click()
        this.isSpinner = false
      }, (error) => {

        this.isSpinner = false
        this._utilityService.openSnackBar("Accident Pdf download Failed!", "OK")

        console.log('accident pdf genarate some error occure ', error)
      })
    }
  }


  submitIncidentDetails() {
    console.log("ACCIDENT DETAILS", this.accident.value)
    let obj = {
      _id: this.singleAccident._id,
      title: this.singleAccident.title,
      type: this.singleAccident.type,
      user: this.singleAccident.createdBy._id,
      date: this.singleAccident.date,
      location: this.singleAccident.location,
      description: this.singleAccident.description || "",
      files: this.singleAccident.files,
      details: this.accident.value
    }
    console.log("SINGLE INCIDENT DETAILS", this.singleAccident)
    this.accidentService.editAccident(obj).subscribe((updated) => {
      console.log("DETAILS UPDATED", updated)
      this._utilityService.handleSnackBar({ msg: "Incident updated successfully!", button: "Ok" })
    }, error => {
      console.log("ERROR WHILE UPDATE DETAIILS", error)
      this._utilityService.handleSnackBar({ msg: "Accident Update Failed!", button: "Ok" })
    })

  }
}


